/* eslint-disable react-hooks/exhaustive-deps */

import { useAuth } from "context/AuthContext";
import { Outlet } from "react-router";
import { UserInfo } from "components/user-info";

import "./styles.scss";
import { NavLink } from "react-router-dom";
import { NavMenu } from "components/navmenu";
import { Helmet } from "react-helmet-async";
import { useEffect, useState, useMemo, useRef, useCallback } from "react";
import { useModal } from "context/ModalContext";
import { RegulamentoFooter } from "components/regulamento-footer";
import { RegulamentoLink } from "components/regulamento-link";
import { FaStar, FaBoxOpen, FaCartArrowDown  } from "react-icons/fa";
import { purchaseItem, getTransparencia, getCatalogItems } from "services/store.service";
import { toast } from "react-toastify";
import Tippy from "@tippyjs/react";
import { Button, Modal } from "flowbite-react";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { Scrollbars } from "react-custom-scrollbars-2";
import {
  getDesafios,
  getDesafiosConquistados, 
  getPontosDistribuidos, 
  getTotaItensCadastradosLoja, 
  getPremiosDistribuidos, 
  getRelelatorioAnaliticoResgates 
} from "services/transparencia.service";

import noImage from "assets/img/semImagem.jpg";

import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "components/custom-captcha";
import { IoReload } from "react-icons/io5";
import moment from "moment";
import ReCAPTCHA from 'react-google-recaptcha';
import { jsPDF } from "jspdf";

export function Experiencias() {
  const { refreshUser, user } = useAuth();
  const { showModal } = useModal();
  const [cards, setCards] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<string | undefined>();
  const props = { openModal, setOpenModal };
  const [item, setItem] = useState<any>([]);
  const [orderBy, setOrderBy] = useState("creationDate");
  const [headerProdutos, setHeaderProdutos] = useState<boolean>(false);
  const [headerExpriencias, setHeaderExperiencia] = useState<boolean>(false);
  const [show, setShow] = useState<boolean>(false);
  const [transparencia, setTransparencia] = useState<any>([]);
  const [transparenciaList, setTransparenciaList] = useState<any>([]);
  const [showCaptcha, setShowCaptcha] = useState<boolean>(true);

  
  const [desafios, setDesafios] = useState<any>();
  const [desafiosConquistados, setDesafiosConquistados] = useState<any>();
  const [pontosDistribuidos, setPontosDistribuidos] = useState<any>();
  const [totalItensLoja, setTotalItensLoja] = useState<any[]>([]);
  const [premiosDistribuidos, setPremiosDistribuidos] = useState<any[]>([]);
  const [relatorioAnalitico, setRelatorioAnalitico] = useState<any[]>([]);
  const [nameFilter, setNameFilter] = useState<string>("");
  const [activeTab, setActiveTab] = useState<string>("numeros");
  const [loadingTransparencia, setLoadingTransparencia] = useState<boolean>(true);
  const recaptchaV2TokenRef = useRef<string | null>(null);
  const [recaptchaKey, setRecaptchaKey] = useState<number>(0);
  const [isRecaptchaValid, setIsRecaptchaValid] = useState<boolean>(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const handleRecaptchaChange = useCallback((token: string | null) => {
    console.log('✅ reCAPTCHA onChange:', token ? 'Token recebido' : 'Token null');
    if (token) {
      recaptchaV2TokenRef.current = token;
      //setIsRecaptchaValid(true);
    }
  }, []);

  const handleRecaptchaExpired = useCallback(() => {
    console.log('⏰ reCAPTCHA expirado');
    recaptchaV2TokenRef.current = null;
    setIsRecaptchaValid(false);
  }, []);

  const handleRecaptchaError = useCallback(() => {
    console.log('❌ reCAPTCHA erro');
    recaptchaV2TokenRef.current = null;
    setIsRecaptchaValid(false);
  }, []);

  const filteredRelatorio = useMemo(() => {
    const rawFilter = (nameFilter || "").trim().toLowerCase();
    if (!rawFilter) return (relatorioAnalitico || []);
    return (relatorioAnalitico || []).filter((item: any) => {
      const itemName = (item.item_name || "").toString().toLowerCase();
      return itemName.includes(rawFilter);
    });
  }, [relatorioAnalitico, nameFilter]);

  async function loadItems() {
    const data = await getCatalogItems("experiencias");
    data.forEach((obj: any) => {
      if (obj.extra?.experiencia === true) {
        setHeaderExperiencia(true);
      }

      if (obj.extra?.experiencia !== true) {
        setHeaderProdutos(true);
      }
    });

    setCards(data);
    setLoading(false);
  }

  useEffect(() => {
    if (user) {
      setLoading(true);
      loadItems();

      getTransparencia().then(function (data) {
        const sortedData = [...data].sort(
          (a, b) => new Date(b.startPeriod).getTime() - new Date(a.startPeriod).getTime()
        );
        setTransparencia(sortedData[0]);
        setTransparenciaList(sortedData);
        setLoading(false);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [user]);

  useEffect(() => {
    if (user && transparencia.startPeriod && transparencia.endPeriod) {
      setLoadingTransparencia(true);
      
      (async () => {
        try {
          // 1. Desafios
          const desafiosData = await getDesafios(transparencia.startPeriod, transparencia.endPeriod);
          setDesafios(desafiosData[0]);
          
          // 2. Desafios Conquistados
          const desafiosConquistadosData = await getDesafiosConquistados(transparencia.startPeriod, transparencia.endPeriod);
          setDesafiosConquistados(desafiosConquistadosData[0]);
          
          // 3. Pontos Distribuidos
          const pontosDistribuidosData = await getPontosDistribuidos(transparencia.startPeriod, transparencia.endPeriod);
          setPontosDistribuidos(pontosDistribuidosData[0]);
          
          // 4. Total Itens Cadastrados Loja
          const totalItensData = await getTotaItensCadastradosLoja(transparencia.startPeriod, transparencia.endPeriod);
          setTotalItensLoja(totalItensData || []);
          
          // 5. Premios Distribuidos (última chamada - finaliza loading)
          const premiosDistribuidosData = await getPremiosDistribuidos(transparencia.startPeriod, transparencia.endPeriod);
          setPremiosDistribuidos(premiosDistribuidosData || []);
          
        } catch (error) {
          console.error("Erro ao carregar dados de transparência:", error);
        } finally {
          setLoadingTransparencia(false);
        }
      })();
    }
  }, [user, transparencia]);

  useEffect(() => {
    if (activeTab === "relatorio" && transparencia.startPeriod && transparencia.endPeriod) {
      setLoadingTransparencia(true);
      getRelelatorioAnaliticoResgates(transparencia.startPeriod, transparencia.endPeriod).then(function (data) {
        setRelatorioAnalitico(data);
      }).finally(() => {
        setLoadingTransparencia(false);
      });
    }
  }, [activeTab, transparencia]);


  async function purchase(item: any) {
    if (!!user?._id) {
      // Usar apenas reCAPTCHA v2 com checkbox
      const token = recaptchaV2TokenRef.current;
      
      if (!token) {
        console.error('❌ Token reCAPTCHA não disponível');
        toast.error('Por favor, marque o checkbox do reCAPTCHA', {
          position: "top-right",
          autoClose: 3000,
        });
        return;
      }
      
      console.log('✅ Token reCAPTCHA validado, processando compra...');

      purchaseItem(item._id, user._id, token).then(function (data) {
        if (data.status === "OK") {
          toast(
            `👍 sua experiência/produto foi adquirida. A GEMAC entrará em contato com você em até 48h para agendar a entrega.`,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            }
          );
          recaptchaV2TokenRef.current = null;
          
          refreshUser();
        } else if (data.status === "UNAUTHORIZED") {
          if (data.restrictions.indexOf("insufficient_requirements") !== -1) {
            showMessageError("Estrelas insuficientes para realizar o resgate.");
          } else if (
            data.restrictions.indexOf("exceeded_purchase_limit") !== -1
          ) {
            showMessageError(
              "Limite de resgate da experiência/produto atingido."
            );
          } else if (data.restrictions.indexOf("item_does_not_exist") !== -1) {
            showMessageError("O item não existe mais.");
          } else if (
            data.restrictions.indexOf("player_does_not_exist") !== -1
          ) {
            showMessageError("O player informado para o resgate não existe.");
          } else if (data.restrictions.indexOf("item_disabled") !== -1) {
            showMessageError("Este item está desabilitado");
          } else if (data.restrictions.indexOf("item_out_of_time") !== -1) {
            showMessageError(
              "Ultrapassado o período para resgate da experiência/produto."
            );
          } else if (data.restrictions.indexOf("limit_exceeded") !== -1) {
            showMessageError(
              "Você já reaizou o resgate desta experiência/produto."
            );
          } else if (data.restrictions.indexOf("item_sold_out") !== -1) {
            showMessageError("Este item está esgotado.");
          } else if (
            data.restrictions.indexOf("principal_not_allowed") !== -1
          ) {
            showMessageError("Você não tem permissão para realizar o resgate.");
          } else if (
            data.restrictions.indexOf("inactive_user_not_allowed") !== -1
          ) {
            showMessageError("Seu usuário está inativo e não pode realizar o resgate.");
          }
          else {
            toast(`❌ Ocorreu um erro, tente novamente mais tarde.`, {
              position: "top-right",
              autoClose: 5000
            });
          }
        } else {
          toast(`❌ Ocorreu um erro, tente novamente mais tarde.`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
      props.setOpenModal(undefined);
    }
  }

  function showMessageError(text: string) {
    toast.error(`${text}`, {
      position: "top-right",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  }

  function isItemLocked(item: any) {
    var ok = 0;
    if (item && item.requires) {
      item.requires.forEach(function (o: any) {
        if (o.type === 0) {
          if (o.total === 0) {
            ok = ok + 1;
          } else if (
            user?.point_categories[o.item] &&
            user?.point_categories[o.item] >= o?.total
          ) {
            ok = ok + 1;
          }
        } else if (
          o.type === 1 &&
          user?.challenges[o.item] &&
          user?.challenges[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (
          o.type === 2 &&
          user?.catalog_items[o.item] &&
          user?.catalog_items[o.item] >= o?.total
        ) {
          ok = ok + 1;
        } else if (o.type >= 3) {
          //ignorar qualquer outro tipo como level, crowning etc.
          ok = ok + 1;
        }
      });
    } else if (!item.requires) {
      ok = ok + 1;
    }

    return !(ok === item.requires.length);
  }

  function isItemLockedByDate(item: any) {
    var locked = null;
    if (item && item.requires) {
      if(item.start){
        if (item.start > new Date().getTime()) {
          locked = "start";
        }
      }  
      if(item.end){
        if (item.end < new Date().getTime()) {
          locked = "end";
        }
      }   
    }
    return locked;
  }

  const handleChange = (event: any) => {
    setOrderBy(event.target.value);
  };

  const sortedCards = [...cards];

  if (orderBy === "alphabetical") {
    sortedCards.sort((a, b) => a.name.localeCompare(b.name));
  } else if (orderBy === "priceUp") {
    sortedCards.sort((a, b) => a.requires[0].total - b.requires[0].total);
  } else if (orderBy === "priceDown") {
    sortedCards.sort((a, b) => b.requires[0].total - a.requires[0].total);
  } else if (orderBy === "creationDate") {
    sortedCards.sort(
      (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
    );
  }

  function doSubmit() {
    const userCaptchaElement = document.getElementById(
      "user_captcha_input"
    ) as HTMLInputElement;

    if (userCaptchaElement) {
      const value = userCaptchaElement.value;
      if (validateCaptcha(value)) {
        setShowCaptcha(false);
        console.log("Captcha correspondente");
      } else {
        alert("Captcha não corresponde, tente novamente.");
      }
    }
  }

  const downloadDocument = () => {
    window.open(transparencia.document.url);
  };

  const toggleRegulation = (e: any) => {
    const element = document.getElementById("transparenciaFooter");

    if (!element) return;
    if (element.classList.contains("close")) {
      element.classList.remove("close");
      element.classList.add("open");
      setShow(true);
    } else {
      element.classList.remove("open");
      element.classList.add("close");
      setShow(false);
    }
  }; 
    
  
  function showTab(tab: string){
    setActiveTab(tab);
  }

  function escapeHtml(unsafe: any) {
    if (unsafe === null || unsafe === undefined) return "";
    return String(unsafe)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function exportTableAsPdf() {
    try {
      const doc = new jsPDF("l", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Título
      doc.setFontSize(16);
      doc.setTextColor(0, 51, 160); // #0033A0
      doc.setFont("helvetica", "bold");
      doc.text("Relatório Analítico de Resgates", pageWidth / 2, 15, { align: "center" });

      // Data
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");
      doc.text(`Gerado em ${moment().format("DD/MM/YYYY [às] HH:mm")}`, pageWidth / 2, 22, { align: "center" });

      // Cabeçalho da tabela
      const headers = ["#", "ITEM", "CPF", "DATA DO RESGATE", "MILISSEGUNDOS"];
      const colWidths = [12, 50, 40, 50, 40];
      const rows = (filteredRelatorio || []).map((item: any, index: number) => [
        String(index + 1),
        item.item_name || "",
        item.cpf || "",
        moment(item.time).format("DD/MM/YYYY HH:mm") || "",
        item.milissegundos || ""
      ]);

      let y = 30;
      const headerHeight = 8;
      const rowHeight = 7;
      const maxRowsPerPage = 30;

      // Função para desenhar cabeçalho
      const drawHeader = () => {
        doc.setFillColor(0, 174, 239); // #00AEEF
        doc.setTextColor(255, 255, 255);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);

        let x = 10;
        headers.forEach((header, i) => {
          doc.rect(x, y - headerHeight + 1, colWidths[i], headerHeight, "F");
          doc.text(header, x + 2, y - 1, { maxWidth: colWidths[i] - 2 });
          x += colWidths[i];
        });

        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        y += headerHeight;
      };

      // Desenhar primeira linhaheader
      drawHeader();

      // Desenhar linhas
      let rowIndex = 0;
       rows.forEach((row: any[], rowIdx: number) => {
        if (rowIndex >= maxRowsPerPage) {
          doc.addPage();
          y = 20;
          drawHeader();
          rowIndex = 0;
        }

        let x = 10;
         // Cores alternadas
         if (rowIdx % 2 === 0) {
           doc.setFillColor(255, 255, 255);
         } else {
           doc.setFillColor(240, 251, 255);
         }
        doc.rect(x - 1, y, pageWidth - 12, rowHeight, "F");

        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);

         row.forEach((cell: any, i: number) => {
          doc.text(String(cell), x + 2, y + 5, { maxWidth: colWidths[i] - 4 });
          x += colWidths[i];
        });

        y += rowHeight;
        rowIndex++;
      });

      // Rodapé
      const totalPages = doc.internal.pages.length - 1;
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.setTextColor(128, 128, 128);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text(`Página ${i}`, pageWidth / 2, pageHeight - 10, { align: "center" });
      }

      // Salvar
      doc.save(`relatorio-resgates-${moment().format("YYYY-MM-DD_HHmmss")}.pdf`);
    } catch (err) {
      console.error("Erro ao gerar PDF:", err);
      alert("Erro ao gerar o PDF. Tente novamente.");
    }
  }

  function getTotalItens(chave: string) {
    return premiosDistribuidos.find((e: any) => e.tipo === chave) || {
      total: 0,
      itemName: "-",
    };
  }

  if (!user) return null;

  return (
    <>
      <Helmet>
        <title>CONTA COMIGO BRB</title>
      </Helmet>
      <div id="home-wrapper" className="min-h-screen">
        <div
          className="z-10 relative flex flex-col items-center space-y-0"
          id="experiencias"
        >
          <NavMenu />

          <div className="w-full flex justify-center md:p-0">
            <UserInfo />
          </div>
          <div className="bg-[#0938A3] w-screen text-white md:-mx-10 bgShadow">
            <div className="w-full md:w-[1200px] mx-auto p-5 md:p-8">
              <h2>
                Confira as <strong>Opções disponíveis</strong>
              </h2>
              <p>
                Você possui{" "}
                <strong>{user?.pointCategories?.star || 0} estrelas</strong>.
                Troque suas estrelas pelo que preferir entre as opções abaixo.
              </p>
              <RegulamentoLink
                type="mercado_estrelas"
                label="Confira o regulamento do mercado de estrelas aqui"
                className="mt-3"
              />
            </div>
          </div>
          <div className="bg-[#F2F2F2] w-screen text-white md:-mx-10 sectionExp">
            <div className="w-full md:w-[1200px] mx-auto  p-5 md:p-8">
              <div className="flex justify-end items-center mb-4">
                <span className="text-[#000]">Filtrar por: </span>
                <select
                  value={orderBy}
                  onChange={handleChange}
                  className="text-[#000] ml-2"
                >
                  <option value="">Selecione uma opção</option>
                  <option value="creationDate">Mais recentes</option>
                  <option value="priceDown">Maior preço</option>
                  <option value="priceUp">Menor preço</option>
                  <option value="alphabetical">Ordem alfabética</option>
                </select>
              </div>
              {loading && <p className="text-center loading">CARREGANDO...</p>}
              {headerProdutos && (
                <h3 className="font-bold border-b-2 mb-4 text-[#88e1f2] uppercase text-[1.8em]">
                  Produtos
                </h3>
              )}
              <ul className="listItems grid lg:grid-cols-4">
                {!loading &&
                  sortedCards
                    .filter((e: any) => {
                      return !e.extra?.experiencia;
                    })
                    .map((item: any, i: number) => (
                      <>
                        {item.requires && item.requires.length > 0 && (
                          <li
                            key={item._id}
                            className={`${
                              item.amount !== -1 &&
                              item.amount <= item.redeem &&
                              "opacity-50"
                            }`}
                          >
                            <div className="image">
                              <img
                                src={item.image ? item.image.medium.url : noImage}
                                alt={item.name}
                                title={item.name}
                              />
                            </div>
                            <div className="content">
                              {(item.extra?.tipoEnvio)?.trim()?.toLowerCase() === "retirada" ? (
                                <p className="itemType" title="Este produto deve ser retirado no CNC após aviso por e-mail">
                                  {item.extra.tipoEnvio}
                                </p>
                              ) : null}
                              <span className="qtdStar">
                                {item.requires[0].total} <FaStar size={18} />
                              </span>
                              <h3>{item.name}</h3>
                              <p className="estoque"><FaBoxOpen className="mr-1"/> Estoque: {item.amount === -1 ? 'Ilimitado' : item.amount}</p>
                              <p className="comrpado"><FaCartArrowDown  className="mr-1"/> Resgatados: {item.redeem}</p>
                              <p>{item.description}</p>

                              {item.amount === -1 || item.amount > item.redeem ? (
                                <>
                                  {!isItemLockedByDate(item) ? (
                                    <Tippy
                                      arrow={false}
                                      className={`${
                                        !isItemLocked(item) && "hidden"
                                      } bg-blue-light drop-shadow-lg p-4`}
                                      content="Você não tem estrelas suficientes"
                                    >
                                      <div>
                                        <button
                                          disabled={isItemLocked(item)}
                                          className={`${
                                            isItemLocked(item) && "opacity-20"
                                          }`}
                                          onClick={() => {
                                            loadCaptchaEnginge(6, "darkgrey", "white", "", 10, true);
                                            props.setOpenModal("pop-up");
                                            setItem(item);
                                          }}
                                        >
                                          RESGATAR -&gt;
                                        </button>
                                      </div>
                                    </Tippy>
                                  ) : (
                                    <>
                                      {isItemLockedByDate(item) === 'start' && (
                                        <Tippy
                                            arrow={false}
                                            className={` bg-blue-light drop-shadow-lg p-4`}
                                            content={`O Item ainda não esta liberado para compra somente em ${moment(item.start).format("DD/MM/yyyy HH:mm")}`}
                                          >
                                          <div>
                                            <button
                                              disabled={true}
                                              className="opacity-20"
                                              
                                            >
                                              RESGATAR -&gt;
                                            </button>
                                            <div className="text-center text-[0.9em]">Libera em: {moment(item.start).format("DD/MM/yyyy HH:mm")}</div>
                                          </div>
                                        </Tippy>
                                      )}
                                      {isItemLockedByDate(item) === 'end' && (
                                        <Tippy
                                            arrow={false}
                                            className={` bg-blue-light drop-shadow-lg p-4`}
                                            content={`O Item estava liberado para compra até ${moment(item.end).format("DD/MM/yyyy HH:mm")}`}
                                          >
                                          <div>
                                            <button
                                              disabled={true}
                                              className="opacity-20"
                                              
                                            >
                                              RESGATAR -&gt;
                                            </button>
                                            <div className="text-center text-[0.9em]">Encerrado em: {moment(item.end).format("DD/MM/yyyy HH:mm")}</div>
                                          </div>
                                        </Tippy>
                                      )}
                                    </>
                                  )}
                                </>
                              ) : (
                                <Tippy
                                  arrow={false}
                                  className="bg-blue-light drop-shadow-lg p-4"
                                  content="O item encontra-se indisponível para compra"
                                >
                                  <div>
                                    <button className="opacity-50 cursor-default">
                                      ESGOTADO
                                    </button>
                                  </div>
                                </Tippy>
                              )}

                              <small>
                                {item.extra && item.extra.text
                                  ? item.extra.text
                                  : ""}
                              </small>
                            </div>
                          </li>
                        )}
                      </>                      
                    ))}
              </ul>
              {headerExpriencias && (
                <h3 className="font-bold border-b-2 mb-4 text-[#88e1f2] uppercase text-[1.8em]">
                  Experiências
                </h3>
              )}
              <ul className="listItems grid lg:grid-cols-4">
                {!loading &&
                  sortedCards
                    .filter((e: any) => {
                      return !!e.extra?.experiencia;
                    })
                    .map((item: any, i: number) => (
                      <>
                        {item.requires && item.requires.length > 0 && (
                          <li
                            key={item._id}
                            className={`${
                              item.amount !== -1 &&
                              item.amount <= item.redeem &&
                              "opacity-50"
                            }`}
                          >
                            <div className="image">
                              <img
                                src={item.image ? item.image.medium.url : noImage}
                                alt={item.name}
                                title={item.name}
                              />
                            </div>
                            <div className="content">
                              {(item.extra?.tipoEnvio)?.trim()?.toLowerCase() === "retirada" ? (
                                <p className="itemType" title="Esta experiência deve ser retirada no CNC após aviso por e-mail">
                                  {item.extra.tipoEnvio}
                                </p>
                              ) : null}
                              <span className="qtdStar">
                                {item.requires[0].total} <FaStar size={18} />
                              </span>
                              <h3>{item.name}</h3>
                              <p className="estoque"><FaBoxOpen className="mr-1"/> Estoque: {item.amount === -1 ? 'Ilimitado' : item.amount}</p>
                              <p className="comrpado"><FaCartArrowDown  className="mr-1"/> Resgatados: {item.redeem}</p>
                              <p>{item.description}</p>

                              {item.amount === -1 || item.amount > item.redeem ? (
                                <>
                                  {!isItemLockedByDate(item) ? (
                                    <Tippy
                                    arrow={false}
                                    className={`${
                                      !isItemLocked(item) && "hidden"
                                    } bg-blue-light drop-shadow-lg p-4`}
                                    content="Você não tem estrelas suficientes"
                                  >
                                    <div>
                                      <button
                                        disabled={isItemLocked(item)}
                                        className={`${
                                          isItemLocked(item) && "opacity-20"
                                        }`}
                                        onClick={() => {
                                          loadCaptchaEnginge(6, "darkgrey", "white", "", 10, true);
                                          props.setOpenModal("pop-up");
                                          setItem(item);
                                        }}
                                      >
                                        RESGATAR -&gt;
                                      </button>
                                    </div>
                                  </Tippy>
                                  ) : (
                                    <>
                                      {isItemLockedByDate(item) === 'start' && (
                                        <Tippy
                                            arrow={false}
                                            className={` bg-blue-light drop-shadow-lg p-4`}
                                            content={`O Item ainda não esta liberado para compra somente em ${moment(item.start).format("DD/MM/yyyy HH:mm")}`}
                                          >
                                          <div>
                                            <button
                                              disabled={true}
                                              className="opacity-20"
                                              
                                            >
                                              RESGATAR -&gt;
                                            </button>
                                            <div className="text-center text-[0.9em]">Libera em: {moment(item.start).format("DD/MM/yyyy HH:mm")}</div>
                                          </div>
                                        </Tippy>
                                      )}
                                      {isItemLockedByDate(item) === 'end' && (
                                        <Tippy
                                            arrow={false}
                                            className={` bg-blue-light drop-shadow-lg p-4`}
                                            content={`O Item estava liberado para compra até ${moment(item.end).format("DD/MM/yyyy HH:mm")}`}
                                          >
                                          <div>
                                            <button
                                              disabled={true}
                                              className="opacity-20"
                                              
                                            >
                                              RESGATAR -&gt;
                                            </button>
                                            <div className="text-center text-[0.9em]">Encerrado em: {moment(item.end).format("DD/MM/yyyy HH:mm")}</div>
                                          </div>
                                        </Tippy>
                                      )}
                                    </>
                                  )}
                                </>
                                
                              ) : (
                                <Tippy
                                  arrow={false}
                                  className="bg-blue-light drop-shadow-lg p-4"
                                  content="O item encontra-se indisponível para compra"
                                >
                                  <div>
                                    <button className="opacity-50 cursor-default">
                                      ESGOTADO
                                    </button>
                                  </div>
                                </Tippy>
                              )}

                              <small>
                                {item.extra && item.extra.text
                                  ? item.extra.text
                                  : ""}
                              </small>
                            </div>
                          </li>
                        )}
                      </>                      
                    ))}
              </ul>
              <Modal
                show={props.openModal === "pop-up"}
                size="md"
                popup
                onClose={() => {
                  props.setOpenModal(undefined);
                  recaptchaV2TokenRef.current = null;
                  setIsRecaptchaValid(false);
                  recaptchaRef.current?.reset();
                }}
              >
                <Modal.Header />
                <Modal.Body>
                  <div className="text-center">
                    <AiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                      <span className="text-[red]">ATENÇÃO:</span> não
                      realizamos reembolso de estrelas ou troca/devolução de
                      produtos. Antes de confirmar um resgate verifique todas as
                      informações sobre o produto ou experiência.
                    </h3>
                    <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                      Você confirma o resgate dessa experiência/produto?
                    </h3>
                    
                    <div className="flex justify-center mb-4">
                      {/* <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6LegWDosAAAAAC8zXorIREza04P6CBDlgeHgC0Zw"
                        onChange={handleRecaptchaChange}
                        onExpired={handleRecaptchaExpired}
                        onErrored={handleRecaptchaError}
                      /> */}
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey="6LeDfmMtAAAAAOtCwQ7dthDwvjbWOa3iWzAEeVZK"
                        onChange={handleRecaptchaChange}
                        onExpired={handleRecaptchaExpired}
                        onErrored={handleRecaptchaError}
                      />
                    </div>
                    
                    <div className="flex justify-center gap-4">
                      <Button
                        color="gray"
                        onClick={() => {
                          props.setOpenModal(undefined);
                          recaptchaV2TokenRef.current = null;
                          setIsRecaptchaValid(false);
                          recaptchaRef.current?.reset();
                        }}
                      >
                        Cancelar
                      </Button>
                      <Button 
                        onClick={() => purchase(item)}
                      >
                        Confirmar
                      </Button>
                    </div>
                  </div>
                </Modal.Body>
              </Modal>
              {!loading && cards?.length === 0 ? (
                <p className="text-center loading text-[#09236b]">
                  Em breve você poderá consultar aqui, as estrelas que
                  conquistou e as experiências disponíveis para resgate.
                </p>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>

        <div className="text-center">
          <div className="">
            <div>
              <button
                className="bg-[#88E1F2] text-[#04227C] w-full py-4 font-bold uppercase"
                onClick={(e) => {
                  toggleRegulation(e);
                }}
              >
                TRANSPARÊNCIA
              </button>
            </div>
          </div>
        </div>

        <div id="transparenciaFooter" className="close">

          <div className="content">
            <div>
              <button
                type="button"
                className="closeRegulation"
                onClick={(e) => {
                  toggleRegulation(e);
                }}
              >
                X
              </button>

              <h2>TRANSPARÊNCIA {moment(transparencia.startPeriod).format("YYYY")}</h2>

              <Scrollbars
                style={{ width: "100%" }}
                className="contentExtrato"
                renderTrackVertical={(props) => (
                  <div {...props} className="track-vertical" />
                )}
              >
                
                <div >
                  
                  {loadingTransparencia && <h3>Carregando...</h3>}
    
                  {!loadingTransparencia &&  (
                    
                      <div>
                        {activeTab === "numeros" && (
                          <div>
                            <img className="mb-[30px]" src={transparencia.image.original.url} alt="" />

                            <div className="text-center py-10">
                              {pontosDistribuidos && pontosDistribuidos.total && (
                                <div>
                                <h1 className="text-5xl font-bold text-[#0044cc]">{pontosDistribuidos.total.toLocaleString('pt-BR')}</h1>
                                <p className="text-gray-600 mt-2 text-lg">Estrelas distribuídas</p>
                                </div>
                              )}
                              
                              <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
                                {totalItensLoja.length > 0 && premiosDistribuidos.length > 0 && (
                                  <>
                                    {totalItensLoja.map((item: any, index: number) => {
                                      const totalItens = getTotalItens(item._id);

                                      return (
                                        <div key={index} className="border border-[#0044cc] rounded-lg overflow-hidden">
                                          <div className="bg-[#0044cc] text-white font-semibold py-3">
                                            {item._id}
                                          </div>
                                          <div className="p-6">
                                            <p className="text-4xl font-bold text-[#0044cc]">{Number(item?.total || 0).toLocaleString('pt-BR')}</p>
                                            <p className="text-gray-600 mt-1">{item.label}</p>
                                            <p className="text-3xl font-bold text-[#0044cc] mt-6">{Number(totalItens.total || 0).toLocaleString('pt-BR')}</p>
                                            <p className="text-gray-600 mt-1">{totalItens.itemName}</p>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </>
                                )} 
                              </div>
                            </div>

                            <div className="flex">
                              {transparenciaList.map((item: any, index: number) => (
                                <button key={index} className="block bg-[#0044cc] text-white border border-white rounded-lg px-8 py-2.5 my-5 mb-0 mr-3 font-bold text-[1.1em]" onClick={()=>setTransparencia(item)}>
                                    ANO {moment(item.startPeriod).format("YYYY")} 
                                  </button>
                              ))}
                            </div>

                        </div>
                      )}
    
                      {activeTab === "relatorio" && (
                          <div>
                            {loadingTransparencia ? (<h3>Carregando...</h3>) : (
                              <div>
                                <div className="flex items-center gap-3">
                                  <button className="block bg-[#88e1f2] text-white border border-white rounded-lg px-8 py-2.5 my-5 my-[50px] font-bold text-[1.1em]" onClick={()=>showTab("numeros")}>
                                    Voltar <i className="gg-software-download"></i>
                                  </button>
                                  <button className="block bg-[#0066cc] text-white border border-white rounded-lg px-4 py-2 my-5 my-[50px] font-bold text-[0.95em]" onClick={exportTableAsPdf}>
                                    Baixar PDF
                                  </button>
                                </div>
                                
                                <div className="mb-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                                  <div className="flex items-center gap-2">
                                    <label className="font-semibold">Filtrar por ITEM:</label>
                                    <input
                                      type="text"
                                      className="border rounded px-3 py-1 text-sm"
                                      placeholder="Digite o nome do item"
                                      value={nameFilter}
                                      onChange={(e) => setNameFilter(e.target.value)}
                                    />
                                  </div>
                                  <div className="text-sm text-gray-600">Total: {filteredRelatorio.length}</div>
                                </div>
    
                                <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden text-sm text-gray-700 shadow-sm">
                                  <thead className="bg-[#00AEEF] text-white">
                                    <tr>
                                      <th></th>
                                      <th className="px-4 py-3 text-left font-semibold">ITEM</th>
                                      <th className="px-4 py-3 text-left font-semibold">CPF</th>
                                      <th className="px-4 py-3 text-left font-semibold">DATA DO RESGATE</th>
                                      <th className="px-4 py-3 text-left font-semibold">MILISSEGUNDOS</th>
                                    </tr>
                                  </thead>
    
                                  <tbody>
                                    {(
                                      filteredRelatorio
                                    ).map((item: any, index: number) => (
                                      <tr
                                        key={index}
                                        className={`${
                                          index % 2 === 0 ? "bg-white" : "bg-[#f0fbff]"
                                        } hover:bg-[#e2f6ff] transition-colors`}
                                      >
                                        <td className="text-center">{index + 1}</td>
                                        <td className="px-4 py-2 border-t border-gray-200">{item.item_name}</td>
                                        <td className="px-4 py-2 border-t border-gray-200">{item.cpf}</td>
                                        <td className="px-4 py-2 border-t border-gray-200">
                                          {moment(item.time).format("DD/MM/YYYY [às] HH:mm")}
                                        </td>
                                        <td className="px-4 py-2 border-t border-gray-200">{item.milissegundos}</td>
                                      </tr>
                                    ))}
                                    {filteredRelatorio.length === 0 && (
                                      <tr>
                                        <td colSpan={5} className="text-center py-4 text-gray-500">Nenhum registro encontrado</td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
    
                              </div>
                            )}
                            
                        </div>
                      )}
                      
                    </div>
                    
                  )}
                </div>
              </Scrollbars>
            </div>

            

            {activeTab === "numeros" && ( 
              <button className="block bg-[#88e1f2] text-white border border-white rounded-lg px-8 py-2.5 my-5 mb-0 mx-auto my-[50px] font-bold text-[1.1em]" onClick={()=>showTab("relatorio")}>
                Relatório Analítico de Resgates <i className="gg-software-download"></i>
              </button>
            )}

            <p className={`${activeTab === "numeros" ? "mt-2" : "mt-10"} block text-center`}>
              Informação referente ao ano <b>{moment(transparencia.startPeriod).format("YYYY")}</b>
              {moment(transparencia.startPeriod).year() === moment().year() && (
                <> até a data de: <b>{moment(new Date()).format("DD/MM/YYYY [às] HH:mm")}</b></>
              )}
            </p>
    
          </div>
        </div>
        
        <RegulamentoFooter />
      </div>

      <Outlet />
    </>
  );
}